// CRM 2.0 · M12-F4 · CRM 2.0 › Agreement Sign (DC-222), Authorised Signatory: To sign (copies handed to me, re-sign
// first; a copy leaves when every QR page is checked) and Signed (my signed agreements, newest first, View). "Scan any
// QR" at the bottom reads one QR without choosing an agreement first.
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import cls from "./Crm2Verify.module.css";
import { supabase } from "../../supabaseClient";
import { listMyAgreements } from "../../Services/Crm2Verify";
import { errorTost } from "../../Services/Toast";

export function Progress({ checked, total }) {
  const pct = total ? Math.round((checked / total) * 100) : 0;
  return (
    <>
      <div className={cls.bar} role="progressbar" aria-valuemin={0} aria-valuemax={total} aria-valuenow={checked}>
        <div className={cls.barFill} style={{ width: `${pct}%` }} />
      </div>
      <div className={cls.barText}><span>{checked} of {total} QR pages checked</span><span>{pct}%</span></div>
    </>
  );
}

function VerifyAgreements() {
  const navigate = useNavigate();
  // the login the server sees (the session token every call sends): one browser keeps one login for all its tabs
  const loginEmail = supabase.auth.session()?.user?.email;
  const [tab, setTab] = useState("toSign");
  const [lists, setLists] = useState({ toSign: null, signed: null });

  useEffect(() => {
    let live = true;
    Promise.all([listMyAgreements("toSign"), listMyAgreements("signed")])
      .then(([toSign, signed]) => live && setLists({ toSign: toSign || [], signed: signed || [] }))
      .catch((e) => errorTost(e.message));
    return () => { live = false; };
  }, []);

  const rows = lists[tab];
  const open = (id) => navigate(`/crm2/verify-agreements/${id}`);
  return (
    <div className={cls.page}>
      <header className={cls.header}>
        <h1 className={cls.title}>Agreement Sign</h1>
        <p className={cls.who}>Signed in as {loginEmail || "—"}</p>
      </header>

      <div className={cls.segment} role="tablist" aria-label="Agreements">
        <button className={`${cls.seg} ${tab === "toSign" ? cls.segOn : ""}`} role="tab" aria-selected={tab === "toSign"} onClick={() => setTab("toSign")}>
          To sign{lists.toSign && lists.toSign.length > 0 && <span className={cls.count}>{lists.toSign.length}</span>}
        </button>
        <button className={`${cls.seg} ${tab === "signed" ? cls.segOn : ""}`} role="tab" aria-selected={tab === "signed"} onClick={() => setTab("signed")}>
          Signed
        </button>
      </div>

      {!rows && <div className={cls.empty}>Loading…</div>}
      {rows && !rows.length && (
        <div className={cls.empty}>
          <b>{tab === "toSign" ? "Nothing to sign" : "No signed agreements yet"}</b>
          {tab === "toSign" ? "Agreements the Document Desk hands to you appear here." : "An agreement appears here once every QR page is checked."}
        </div>
      )}

      <div className={cls.list}>
        {rows && tab === "toSign" && rows.map((a) => (
          <article key={a.crm2AgreementCopyId} className={cls.card}>
            <div className={cls.cardTop}>
              <div>
                <h2 className={cls.name}>{a.customer || "—"}</h2>
                <p className={cls.unit}>{a.unit}</p>
              </div>
              <span className={`${cls.tag} ${a.resign ? cls.tagDark : ""}`}>{a.resign ? "Re-sign" : `Copy ${a.copyNo}`}</span>
            </div>
            {a.resign && <p className={cls.reason}>{a.resign}</p>}
            {/* marked Not matching but not sent back yet (the app was closed): nothing is forgotten */}
            {a.notMatching > 0 && <p className={cls.reason}>{a.notMatching} {a.notMatching === 1 ? "page" : "pages"} not matching · not sent back yet</p>}
            <Progress checked={a.checked} total={a.total} />
            <button className={`${cls.btn} ${cls.primary} ${cls.wide}`} onClick={() => open(a.crm2AgreementCopyId)}>
              {a.checked > 0 ? "Continue signing" : "Start signing"}
            </button>
          </article>
        ))}
        {rows && tab === "signed" && rows.map((a) => (
          <article key={a.crm2AgreementCopyId} className={cls.card}>
            <div className={cls.cardTop}>
              <div>
                <h2 className={cls.name}>{a.customer || "—"}</h2>
                <p className={cls.unit}>{a.unit}</p>
              </div>
              <span className={cls.tag}>Copy {a.copyNo}</span>
            </div>
            <p className={cls.meta}>Signed {a.signedOn}</p>
            {a.state && <p className={cls.reason}>{a.state === "replaced, re-sign pending" ? "Replaced · re-sign pending" : "Replaced by a later copy"}</p>}
            <button className={`${cls.btn} ${cls.wide}`} onClick={() => open(a.crm2AgreementCopyId)}>View</button>
          </article>
        ))}
      </div>

      <div className={cls.dock}>
        <button className={`${cls.btn} ${cls.primary} ${cls.wide}`} onClick={() => navigate("/crm2/verify-agreements/scan")}>Scan any QR</button>
      </div>
    </div>
  );
}

export default VerifyAgreements;
